//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
export class SituAnalyticsWebApiClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    healthCheck() {
        let url_ = this.baseUrl + "/healthcheck";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processHealthCheck(_response);
        });
    }
    processHealthCheck(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(HealthCheck.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    ping() {
        let url_ = this.baseUrl + "/ping";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processPing(_response);
        });
    }
    processPing(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    downloadReport(request) {
        let url_ = this.baseUrl + "/DownloadReport";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadReport(_response);
        });
    }
    processDownloadReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DownloadReportResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getMostPopularRenderedHomesByBuilder(request) {
        let url_ = this.baseUrl + "/GetMostPopularRenderedHomesByBuilder";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetMostPopularRenderedHomesByBuilder(_response);
        });
    }
    processGetMostPopularRenderedHomesByBuilder(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetMostPopularRenderedHomesByBuilderResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getRecipeEventSummaryByArtifactId(request) {
        let url_ = this.baseUrl + "/GetRecipeEventSummaryByArtifactId";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetRecipeEventSummaryByArtifactId(_response);
        });
    }
    processGetRecipeEventSummaryByArtifactId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRecipeEventSummaryByArtifactIdResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getRecipeEventSummaryByArtifactKey(request) {
        let url_ = this.baseUrl + "/GetRecipeEventSummaryByArtifactKey";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetRecipeEventSummaryByArtifactKey(_response);
        });
    }
    processGetRecipeEventSummaryByArtifactKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRecipeEventSummaryByArtifactKeyResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getRecipeEventSummaryById(request) {
        let url_ = this.baseUrl + "/api/queries/GetRecipeEventSummaryById";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetRecipeEventSummaryById(_response);
        });
    }
    processGetRecipeEventSummaryById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRecipeEventSummaryByIdResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getRendererConfig(request) {
        let url_ = this.baseUrl + "/GetRendererConfig";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetRendererConfig(_response);
        });
    }
    processGetRendererConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRendererConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getRenderer(request) {
        let url_ = this.baseUrl + "/GetRenderer";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetRenderer(_response);
        });
    }
    processGetRenderer(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRendererResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getRendererNames(request) {
        let url_ = this.baseUrl + "/api/GetRendererNames";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetRendererNames(_response);
        });
    }
    processGetRendererNames(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRendererNamesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getReport(request) {
        let url_ = this.baseUrl + "/api/GetReport";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetReport(_response);
        });
    }
    processGetReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetReportResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSession(request) {
        let url_ = this.baseUrl + "/api/queries/GetSession";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSession(_response);
        });
    }
    processGetSession(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRendererResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getUsageSummaryReport(request) {
        let url_ = this.baseUrl + "/api/GetUsageSummaryReport";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetUsageSummaryReport(_response);
        });
    }
    processGetUsageSummaryReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetUsageSummaryReportResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    isReportReady(request) {
        let url_ = this.baseUrl + "/IsReportReady";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processIsReportReady(_response);
        });
    }
    processIsReportReady(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = IsReportReadyResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listProductImpressions(request) {
        let url_ = this.baseUrl + "/ListProductImpressions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListProductImpressions(_response);
        });
    }
    processListProductImpressions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListProductImpressionsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listProductImpressionsGraphData(request) {
        let url_ = this.baseUrl + "/ListProductImpressionsGraph";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListProductImpressionsGraphData(_response);
        });
    }
    processListProductImpressionsGraphData(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListProductImpressionsGraphDataResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listQueues(request) {
        let url_ = this.baseUrl + "/ListQueues";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListQueues(_response);
        });
    }
    processListQueues(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListQueuesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listRecipeEventSummaries(request) {
        let url_ = this.baseUrl + "/api/queries/ListRecipeEventSummaries";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListRecipeEventSummaries(_response);
        });
    }
    processListRecipeEventSummaries(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListRecipeEventSummariesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listRenderers(request) {
        let url_ = this.baseUrl + "/ListRenderers";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListRenderers(_response);
        });
    }
    processListRenderers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListRenderersResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listSessions(request) {
        let url_ = this.baseUrl + "/api/queries/ListSessions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListSessions(_response);
        });
    }
    processListSessions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListSessionsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listSituConnectSummaries(request) {
        let url_ = this.baseUrl + "/api/queries/ListSituConnectSummaries";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListSituConnectSummaries(_response);
        });
    }
    processListSituConnectSummaries(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListSituConnectSummariesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listUsageSummaries(request) {
        let url_ = this.baseUrl + "/api/ListUsageSummaries";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListUsageSummaries(_response);
        });
    }
    processListUsageSummaries(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListUsageSummariesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listViewHomeLogItems(request) {
        let url_ = this.baseUrl + "/ListViewHomeLogItems";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListViewHomeLogItems(_response);
        });
    }
    processListViewHomeLogItems(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListViewHomeLogItemsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addQueue(request) {
        let url_ = this.baseUrl + "/api/commands/AddQueue";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddQueue(_response);
        });
    }
    processAddQueue(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddQueueResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createDailyProductImpressionCsvReport(request) {
        let url_ = this.baseUrl + "/CreateDailyProductImpressionCsvReport";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateDailyProductImpressionCsvReport(_response);
        });
    }
    processCreateDailyProductImpressionCsvReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateDailyProductImpressionCsvReportResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createLegacyMonthlyCsvReport(request) {
        let url_ = this.baseUrl + "/CreateLegacyMonthlyCsvReport";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateLegacyMonthlyCsvReport(_response);
        });
    }
    processCreateLegacyMonthlyCsvReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateLegacyMonthlyCsvReportResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createProductImpressionCsvReport(request) {
        let url_ = this.baseUrl + "/CreateProductImpressionCsvReport";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateProductImpressionCsvReport(_response);
        });
    }
    processCreateProductImpressionCsvReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateProductImpressionCsvReportResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createViewHomeLogItemsCsvReport(request) {
        let url_ = this.baseUrl + "/CreateViewHomeLogItemsCsvReport";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateViewHomeLogItemsCsvReport(_response);
        });
    }
    processCreateViewHomeLogItemsCsvReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateViewHomeLogItemsCsvReportResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    rendererHealthcheck(request) {
        let url_ = this.baseUrl + "/api/commands/RendererHealthcheck";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRendererHealthcheck(_response);
        });
    }
    processRendererHealthcheck(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RendererHealthcheckResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateRendererQueue(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateRendererQueue";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateRendererQueue(_response);
        });
    }
    processUpdateRendererQueue(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateRendererQueueResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateRendererQueuePriorities(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateRendererQueuePriorities";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateRendererQueuePriorities(_response);
        });
    }
    processUpdateRendererQueuePriorities(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateRendererQueuePrioritiesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class HealthCheck {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.service = _data["service"];
            this.status = _data["status"];
            this.reason = _data["reason"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheck();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["status"] = this.status;
        data["reason"] = this.reason;
        return data;
    }
}
export class SituResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SituResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class DownloadReportResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.report = _data["report"] ? Stream.fromJS(_data["report"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadReportResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["report"] = this.report ? this.report.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class MarshalByRefObject {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MarshalByRefObject' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class Stream extends MarshalByRefObject {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.canRead = _data["canRead"];
            this.canWrite = _data["canWrite"];
            this.canSeek = _data["canSeek"];
            this.canTimeout = _data["canTimeout"];
            this.length = _data["length"];
            this.position = _data["position"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Stream' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["canSeek"] = this.canSeek;
        data["canTimeout"] = this.canTimeout;
        data["length"] = this.length;
        data["position"] = this.position;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        super.toJSON(data);
        return data;
    }
}
export class DownloadReportRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadReportRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class PagedResponseOfViewMostPopularHomeLogItem extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(ViewMostPopularHomeLogItem.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfViewMostPopularHomeLogItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class GetMostPopularRenderedHomesByBuilderResponse extends PagedResponseOfViewMostPopularHomeLogItem {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["logItems"])) {
                this.logItems = [];
                for (let item of _data["logItems"])
                    this.logItems.push(ViewMostPopularHomeLogItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMostPopularRenderedHomesByBuilderResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logItems)) {
            data["logItems"] = [];
            for (let item of this.logItems)
                data["logItems"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ViewMostPopularHomeLogItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.type = _data["type"];
            this.builder = _data["builder"];
            this.homeName = _data["homeName"];
            this.facade = _data["facade"];
            this.themes = _data["themes"];
            this.options = _data["options"];
            this.artifactId = _data["artifactId"];
            this.productName = _data["productName"];
            this.numberOfViews = _data["numberOfViews"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ViewMostPopularHomeLogItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["builder"] = this.builder;
        data["homeName"] = this.homeName;
        data["facade"] = this.facade;
        data["themes"] = this.themes;
        data["options"] = this.options;
        data["artifactId"] = this.artifactId;
        data["productName"] = this.productName;
        data["numberOfViews"] = this.numberOfViews;
        return data;
    }
}
export var ProductName;
(function (ProductName) {
    ProductName[ProductName["Panorama"] = 0] = "Panorama";
    ProductName[ProductName["VR"] = 1] = "VR";
    ProductName[ProductName["RayTraced"] = 2] = "RayTraced";
    ProductName[ProductName["Plan"] = 3] = "Plan";
    ProductName[ProductName["Render"] = 4] = "Render";
    ProductName[ProductName["Facade"] = 5] = "Facade";
    ProductName[ProductName["Insights"] = 6] = "Insights";
    ProductName[ProductName["Vanity"] = 7] = "Vanity";
    ProductName[ProductName["AssetModule"] = 8] = "AssetModule";
    ProductName[ProductName["RayTracedPlus"] = 9] = "RayTracedPlus";
    ProductName[ProductName["ProductPreview"] = 10] = "ProductPreview";
    ProductName[ProductName["IfcPreview"] = 11] = "IfcPreview";
    ProductName[ProductName["Connect"] = 12] = "Connect";
    ProductName[ProductName["Unreal"] = 13] = "Unreal";
})(ProductName || (ProductName = {}));
export class PagedRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}
export class GetMostPopularRenderedHomesByBuilderRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.ownerId = _data["ownerId"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.home = _data["home"];
            this.theme = _data["theme"];
            this.masterFile = _data["masterFile"];
            this.daysPreviousToSearch = _data["daysPreviousToSearch"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetMostPopularRenderedHomesByBuilderRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["home"] = this.home;
        data["theme"] = this.theme;
        data["masterFile"] = this.masterFile;
        data["daysPreviousToSearch"] = this.daysPreviousToSearch;
        super.toJSON(data);
        return data;
    }
}
export class GetRecipeEventSummaryByArtifactIdResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.recipeEventSummary = _data["recipeEventSummary"] ? RecipeEventSummary.fromJS(_data["recipeEventSummary"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecipeEventSummaryByArtifactIdResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["recipeEventSummary"] = this.recipeEventSummary ? this.recipeEventSummary.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class RecipeEventSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.artifactId = _data["artifactId"];
            this.queueId = _data["queueId"];
            this.queueName = _data["queueName"];
            this.rendererId = _data["rendererId"];
            this.rendererName = _data["rendererName"];
            this.artifactKey = _data["artifactKey"];
            if (Array.isArray(_data["baseIngredients"])) {
                this.baseIngredients = [];
                for (let item of _data["baseIngredients"])
                    this.baseIngredients.push(BaseIngredient.fromJS(item));
            }
            this.productName = _data["productName"];
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.warpEnvironment = _data["warpEnvironment"];
            this.sourceType = _data["sourceType"];
            this.sourceName = _data["sourceName"];
            this.home = _data["home"];
            this.masterFile = _data["masterFile"];
            this.options = _data["options"];
            this.themes = _data["themes"];
            this.initialPositionInQueue = _data["initialPositionInQueue"];
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : undefined;
            this.dateQueued = _data["dateQueued"] ? new Date(_data["dateQueued"].toString()) : undefined;
            this.dateCancelled = _data["dateCancelled"] ? new Date(_data["dateCancelled"].toString()) : undefined;
            this.dateStarted = _data["dateStarted"] ? new Date(_data["dateStarted"].toString()) : undefined;
            this.dateCompleted = _data["dateCompleted"] ? new Date(_data["dateCompleted"].toString()) : undefined;
            this.dateFailed = _data["dateFailed"] ? new Date(_data["dateFailed"].toString()) : undefined;
            this.totalSecondsInQueue = _data["totalSecondsInQueue"];
            this.secondsFromStartToFirstFileFound = _data["secondsFromStartToFirstFileFound"];
            this.secondsFromStartToFirstFileAdded = _data["secondsFromStartToFirstFileAdded"];
            this.secondsFromStartToFloorplanFilesAdded = _data["secondsFromStartToFloorplanFilesAdded"];
            this.secondsFromStartToFirstPanoramaAdded = _data["secondsFromStartToFirstPanoramaAdded"];
            this.totalSecondsAtRenderer = _data["totalSecondsAtRenderer"];
            this.totalTimeInSeconds = _data["totalTimeInSeconds"];
            this.totalNumberOfJobs = _data["totalNumberOfJobs"];
            this.numberOfJobsCompleted = _data["numberOfJobsCompleted"];
            this.numberOfFilesExpected = _data["numberOfFilesExpected"];
            this.numberOfFilesRecieved = _data["numberOfFilesRecieved"];
            this.dateFirstFileFound = _data["dateFirstFileFound"] ? new Date(_data["dateFirstFileFound"].toString()) : undefined;
            this.dateFirstFileAdded = _data["dateFirstFileAdded"] ? new Date(_data["dateFirstFileAdded"].toString()) : undefined;
            this.dateFloorPlansAdded = _data["dateFloorPlansAdded"] ? new Date(_data["dateFloorPlansAdded"].toString()) : undefined;
            this.dateFirstPanoramaFileFound = _data["dateFirstPanoramaFileFound"] ? new Date(_data["dateFirstPanoramaFileFound"].toString()) : undefined;
            this.dateFirstPanoramaFileAdded = _data["dateFirstPanoramaFileAdded"] ? new Date(_data["dateFirstPanoramaFileAdded"].toString()) : undefined;
            this.correlationId = _data["correlationId"];
            this.renderedOutputId = _data["renderedOutputId"];
            this.notifyCompleteChannel = _data["notifyCompleteChannel"];
            this.customerReference = _data["customerReference"];
            if (Array.isArray(_data["jobEventSummaries"])) {
                this.jobEventSummaries = [];
                for (let item of _data["jobEventSummaries"])
                    this.jobEventSummaries.push(JobEventSummary.fromJS(item));
            }
            if (Array.isArray(_data["stageEventSummaries"])) {
                this.stageEventSummaries = [];
                for (let item of _data["stageEventSummaries"])
                    this.stageEventSummaries.push(StageEventSummary.fromJS(item));
            }
            if (Array.isArray(_data["recipeEvents"])) {
                this.recipeEvents = [];
                for (let item of _data["recipeEvents"])
                    this.recipeEvents.push(RecipeEvent.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeEventSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["artifactId"] = this.artifactId;
        data["queueId"] = this.queueId;
        data["queueName"] = this.queueName;
        data["rendererId"] = this.rendererId;
        data["rendererName"] = this.rendererName;
        data["artifactKey"] = this.artifactKey;
        if (Array.isArray(this.baseIngredients)) {
            data["baseIngredients"] = [];
            for (let item of this.baseIngredients)
                data["baseIngredients"].push(item.toJSON());
        }
        data["productName"] = this.productName;
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["warpEnvironment"] = this.warpEnvironment;
        data["sourceType"] = this.sourceType;
        data["sourceName"] = this.sourceName;
        data["home"] = this.home;
        data["masterFile"] = this.masterFile;
        data["options"] = this.options;
        data["themes"] = this.themes;
        data["initialPositionInQueue"] = this.initialPositionInQueue;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : undefined;
        data["dateQueued"] = this.dateQueued ? this.dateQueued.toISOString() : undefined;
        data["dateCancelled"] = this.dateCancelled ? this.dateCancelled.toISOString() : undefined;
        data["dateStarted"] = this.dateStarted ? this.dateStarted.toISOString() : undefined;
        data["dateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : undefined;
        data["dateFailed"] = this.dateFailed ? this.dateFailed.toISOString() : undefined;
        data["totalSecondsInQueue"] = this.totalSecondsInQueue;
        data["secondsFromStartToFirstFileFound"] = this.secondsFromStartToFirstFileFound;
        data["secondsFromStartToFirstFileAdded"] = this.secondsFromStartToFirstFileAdded;
        data["secondsFromStartToFloorplanFilesAdded"] = this.secondsFromStartToFloorplanFilesAdded;
        data["secondsFromStartToFirstPanoramaAdded"] = this.secondsFromStartToFirstPanoramaAdded;
        data["totalSecondsAtRenderer"] = this.totalSecondsAtRenderer;
        data["totalTimeInSeconds"] = this.totalTimeInSeconds;
        data["totalNumberOfJobs"] = this.totalNumberOfJobs;
        data["numberOfJobsCompleted"] = this.numberOfJobsCompleted;
        data["numberOfFilesExpected"] = this.numberOfFilesExpected;
        data["numberOfFilesRecieved"] = this.numberOfFilesRecieved;
        data["dateFirstFileFound"] = this.dateFirstFileFound ? this.dateFirstFileFound.toISOString() : undefined;
        data["dateFirstFileAdded"] = this.dateFirstFileAdded ? this.dateFirstFileAdded.toISOString() : undefined;
        data["dateFloorPlansAdded"] = this.dateFloorPlansAdded ? this.dateFloorPlansAdded.toISOString() : undefined;
        data["dateFirstPanoramaFileFound"] = this.dateFirstPanoramaFileFound ? this.dateFirstPanoramaFileFound.toISOString() : undefined;
        data["dateFirstPanoramaFileAdded"] = this.dateFirstPanoramaFileAdded ? this.dateFirstPanoramaFileAdded.toISOString() : undefined;
        data["correlationId"] = this.correlationId;
        data["renderedOutputId"] = this.renderedOutputId;
        data["notifyCompleteChannel"] = this.notifyCompleteChannel;
        data["customerReference"] = this.customerReference;
        if (Array.isArray(this.jobEventSummaries)) {
            data["jobEventSummaries"] = [];
            for (let item of this.jobEventSummaries)
                data["jobEventSummaries"].push(item.toJSON());
        }
        if (Array.isArray(this.stageEventSummaries)) {
            data["stageEventSummaries"] = [];
            for (let item of this.stageEventSummaries)
                data["stageEventSummaries"].push(item.toJSON());
        }
        if (Array.isArray(this.recipeEvents)) {
            data["recipeEvents"] = [];
            for (let item of this.recipeEvents)
                data["recipeEvents"].push(item.toJSON());
        }
        return data;
    }
}
export class BaseIngredient {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BaseIngredient();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        return data;
    }
}
export var EnvironmentName;
(function (EnvironmentName) {
    EnvironmentName[EnvironmentName["Latest"] = 0] = "Latest";
    EnvironmentName[EnvironmentName["Staging"] = 1] = "Staging";
    EnvironmentName[EnvironmentName["Production"] = 2] = "Production";
    EnvironmentName[EnvironmentName["Fallback"] = 3] = "Fallback";
})(EnvironmentName || (EnvironmentName = {}));
export var SourceType;
(function (SourceType) {
    SourceType[SourceType["Unknown"] = 0] = "Unknown";
    SourceType[SourceType["InternalPortalUser"] = 1] = "InternalPortalUser";
    SourceType[SourceType["CustomerPortalUser"] = 2] = "CustomerPortalUser";
    SourceType[SourceType["InternalApiClient"] = 3] = "InternalApiClient";
    SourceType[SourceType["CustomerApiClient"] = 4] = "CustomerApiClient";
    SourceType[SourceType["ExternalWebsite"] = 5] = "ExternalWebsite";
    SourceType[SourceType["InternalAutomated"] = 6] = "InternalAutomated";
})(SourceType || (SourceType = {}));
export var NotifyCompleteChannel;
(function (NotifyCompleteChannel) {
    NotifyCompleteChannel[NotifyCompleteChannel["None"] = 0] = "None";
    NotifyCompleteChannel[NotifyCompleteChannel["All"] = 1] = "All";
    NotifyCompleteChannel[NotifyCompleteChannel["Email"] = 2] = "Email";
    NotifyCompleteChannel[NotifyCompleteChannel["Teams"] = 3] = "Teams";
})(NotifyCompleteChannel || (NotifyCompleteChannel = {}));
export class JobEventSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.recipeArtifactId = _data["recipeArtifactId"];
            this.recipeEventSummaryId = _data["recipeEventSummaryId"];
            this.jobArtifactId = _data["jobArtifactId"];
            this.rendererId = _data["rendererId"];
            this.recipeArtifactKey = _data["recipeArtifactKey"];
            this.jobArtifactKey = _data["jobArtifactKey"];
            this.dateStarted = _data["dateStarted"] ? new Date(_data["dateStarted"].toString()) : undefined;
            this.dateFailed = _data["dateFailed"] ? new Date(_data["dateFailed"].toString()) : undefined;
            this.dateCompleted = _data["dateCompleted"] ? new Date(_data["dateCompleted"].toString()) : undefined;
            this.totalTimeInSeconds = _data["totalTimeInSeconds"];
            this.totalNumberOfStages = _data["totalNumberOfStages"];
            this.numberOfStagesCompleted = _data["numberOfStagesCompleted"];
            this.errorMessage = _data["errorMessage"];
            this.numberOfFilesExpected = _data["numberOfFilesExpected"];
            this.numberOfFilesRecieved = _data["numberOfFilesRecieved"];
            this.dateFirstFileFound = _data["dateFirstFileFound"] ? new Date(_data["dateFirstFileFound"].toString()) : undefined;
            this.dateFirstFileAdded = _data["dateFirstFileAdded"] ? new Date(_data["dateFirstFileAdded"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new JobEventSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipeArtifactId"] = this.recipeArtifactId;
        data["recipeEventSummaryId"] = this.recipeEventSummaryId;
        data["jobArtifactId"] = this.jobArtifactId;
        data["rendererId"] = this.rendererId;
        data["recipeArtifactKey"] = this.recipeArtifactKey;
        data["jobArtifactKey"] = this.jobArtifactKey;
        data["dateStarted"] = this.dateStarted ? this.dateStarted.toISOString() : undefined;
        data["dateFailed"] = this.dateFailed ? this.dateFailed.toISOString() : undefined;
        data["dateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : undefined;
        data["totalTimeInSeconds"] = this.totalTimeInSeconds;
        data["totalNumberOfStages"] = this.totalNumberOfStages;
        data["numberOfStagesCompleted"] = this.numberOfStagesCompleted;
        data["errorMessage"] = this.errorMessage;
        data["numberOfFilesExpected"] = this.numberOfFilesExpected;
        data["numberOfFilesRecieved"] = this.numberOfFilesRecieved;
        data["dateFirstFileFound"] = this.dateFirstFileFound ? this.dateFirstFileFound.toISOString() : undefined;
        data["dateFirstFileAdded"] = this.dateFirstFileAdded ? this.dateFirstFileAdded.toISOString() : undefined;
        return data;
    }
}
export class StageEventSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.recipeArtifactId = _data["recipeArtifactId"];
            this.recipeEventSummaryId = _data["recipeEventSummaryId"];
            this.jobArtifactId = _data["jobArtifactId"];
            this.jobEventSummaryId = _data["jobEventSummaryId"];
            this.rendererId = _data["rendererId"];
            this.recipeArtifactKey = _data["recipeArtifactKey"];
            this.jobArtifactKey = _data["jobArtifactKey"];
            this.software = _data["software"];
            this.dateStarted = _data["dateStarted"] ? new Date(_data["dateStarted"].toString()) : undefined;
            this.dateFailed = _data["dateFailed"] ? new Date(_data["dateFailed"].toString()) : undefined;
            this.dateCompleted = _data["dateCompleted"] ? new Date(_data["dateCompleted"].toString()) : undefined;
            this.totalTimeInSeconds = _data["totalTimeInSeconds"];
            this.errorMessage = _data["errorMessage"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StageEventSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipeArtifactId"] = this.recipeArtifactId;
        data["recipeEventSummaryId"] = this.recipeEventSummaryId;
        data["jobArtifactId"] = this.jobArtifactId;
        data["jobEventSummaryId"] = this.jobEventSummaryId;
        data["rendererId"] = this.rendererId;
        data["recipeArtifactKey"] = this.recipeArtifactKey;
        data["jobArtifactKey"] = this.jobArtifactKey;
        data["software"] = this.software;
        data["dateStarted"] = this.dateStarted ? this.dateStarted.toISOString() : undefined;
        data["dateFailed"] = this.dateFailed ? this.dateFailed.toISOString() : undefined;
        data["dateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : undefined;
        data["totalTimeInSeconds"] = this.totalTimeInSeconds;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}
export class RecipeEvent {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.recipeEventType = _data["recipeEventType"];
            this.recipeArtifactId = _data["recipeArtifactId"];
            this.recipeArtifactKey = _data["recipeArtifactKey"];
            if (Array.isArray(_data["recipeBaseIngredients"])) {
                this.recipeBaseIngredients = [];
                for (let item of _data["recipeBaseIngredients"])
                    this.recipeBaseIngredients.push(BaseIngredient.fromJS(item));
            }
            this.jobArtifactId = _data["jobArtifactId"];
            this.jobArtifactKey = _data["jobArtifactKey"];
            this.rendererName = _data["rendererName"];
            this.queueName = _data["queueName"];
            this.event = _data["event"];
            this.totalNumberOfJobs = _data["totalNumberOfJobs"];
            this.totalNumberOfStages = _data["totalNumberOfStages"];
            this.software = _data["software"];
            this.fileName = _data["fileName"];
            this.filePath = _data["filePath"];
            this.positionInQueue = _data["positionInQueue"];
            this.warpEnvironment = _data["warpEnvironment"];
            this.sourceType = _data["sourceType"];
            this.sourceName = _data["sourceName"];
            this.dateTimeStamp = _data["dateTimeStamp"] ? new Date(_data["dateTimeStamp"].toString()) : undefined;
            this.correlationId = _data["correlationId"];
            this.renderedOutputId = _data["renderedOutputId"];
            this.notifyCompleteChannel = _data["notifyCompleteChannel"];
            this.customerReference = _data["customerReference"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeEvent();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recipeEventType"] = this.recipeEventType;
        data["recipeArtifactId"] = this.recipeArtifactId;
        data["recipeArtifactKey"] = this.recipeArtifactKey;
        if (Array.isArray(this.recipeBaseIngredients)) {
            data["recipeBaseIngredients"] = [];
            for (let item of this.recipeBaseIngredients)
                data["recipeBaseIngredients"].push(item.toJSON());
        }
        data["jobArtifactId"] = this.jobArtifactId;
        data["jobArtifactKey"] = this.jobArtifactKey;
        data["rendererName"] = this.rendererName;
        data["queueName"] = this.queueName;
        data["event"] = this.event;
        data["totalNumberOfJobs"] = this.totalNumberOfJobs;
        data["totalNumberOfStages"] = this.totalNumberOfStages;
        data["software"] = this.software;
        data["fileName"] = this.fileName;
        data["filePath"] = this.filePath;
        data["positionInQueue"] = this.positionInQueue;
        data["warpEnvironment"] = this.warpEnvironment;
        data["sourceType"] = this.sourceType;
        data["sourceName"] = this.sourceName;
        data["dateTimeStamp"] = this.dateTimeStamp ? this.dateTimeStamp.toISOString() : undefined;
        data["correlationId"] = this.correlationId;
        data["renderedOutputId"] = this.renderedOutputId;
        data["notifyCompleteChannel"] = this.notifyCompleteChannel;
        data["customerReference"] = this.customerReference;
        return data;
    }
}
export var RecipeEventType;
(function (RecipeEventType) {
    RecipeEventType[RecipeEventType["JobStart"] = 1] = "JobStart";
    RecipeEventType[RecipeEventType["Error"] = 2] = "Error";
    RecipeEventType[RecipeEventType["JobEnd"] = 3] = "JobEnd";
    RecipeEventType[RecipeEventType["FileFound"] = 4] = "FileFound";
    RecipeEventType[RecipeEventType["FileAdded"] = 5] = "FileAdded";
    RecipeEventType[RecipeEventType["Queued"] = 6] = "Queued";
    RecipeEventType[RecipeEventType["Cancelled"] = 7] = "Cancelled";
    RecipeEventType[RecipeEventType["StageStart"] = 8] = "StageStart";
    RecipeEventType[RecipeEventType["StageEnd"] = 9] = "StageEnd";
})(RecipeEventType || (RecipeEventType = {}));
export class GetRecipeEventSummaryByArtifactIdRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.includeSummaries = _data["includeSummaries"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecipeEventSummaryByArtifactIdRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["includeSummaries"] = this.includeSummaries;
        return data;
    }
}
export class GetRecipeEventSummaryByArtifactKeyResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.recipeEventSummary = _data["recipeEventSummary"] ? RecipeEventSummary.fromJS(_data["recipeEventSummary"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecipeEventSummaryByArtifactKeyResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["recipeEventSummary"] = this.recipeEventSummary ? this.recipeEventSummary.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetRecipeEventSummaryByArtifactKeyRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            if (Array.isArray(_data["baseIngredients"])) {
                this.baseIngredients = [];
                for (let item of _data["baseIngredients"])
                    this.baseIngredients.push(BaseIngredient.fromJS(item));
            }
            this.includeSummaries = _data["includeSummaries"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecipeEventSummaryByArtifactKeyRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        if (Array.isArray(this.baseIngredients)) {
            data["baseIngredients"] = [];
            for (let item of this.baseIngredients)
                data["baseIngredients"].push(item.toJSON());
        }
        data["includeSummaries"] = this.includeSummaries;
        return data;
    }
}
export class GetRecipeEventSummaryByIdResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.recipeEventSummary = _data["recipeEventSummary"] ? RecipeEventSummary.fromJS(_data["recipeEventSummary"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecipeEventSummaryByIdResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["recipeEventSummary"] = this.recipeEventSummary ? this.recipeEventSummary.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetRecipeEventSummaryByIdRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.includeSummaries = _data["includeSummaries"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecipeEventSummaryByIdRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["includeSummaries"] = this.includeSummaries;
        return data;
    }
}
export class GetRendererConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.rendererConfig = _data["rendererConfig"] ? RendererConfig.fromJS(_data["rendererConfig"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRendererConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rendererConfig"] = this.rendererConfig ? this.rendererConfig.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class RendererConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rendererId = _data["rendererId"];
            this.queueCheckIntervalInMilliseconds = _data["queueCheckIntervalInMilliseconds"];
            this.canProcessMultipleJobs = _data["canProcessMultipleJobs"];
            this.cpuThreshold = _data["cpuThreshold"];
            this.gpuThreshold = _data["gpuThreshold"];
            if (Array.isArray(_data["queues"])) {
                this.queues = [];
                for (let item of _data["queues"])
                    this.queues.push(QueueConfig.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RendererConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rendererId"] = this.rendererId;
        data["queueCheckIntervalInMilliseconds"] = this.queueCheckIntervalInMilliseconds;
        data["canProcessMultipleJobs"] = this.canProcessMultipleJobs;
        data["cpuThreshold"] = this.cpuThreshold;
        data["gpuThreshold"] = this.gpuThreshold;
        if (Array.isArray(this.queues)) {
            data["queues"] = [];
            for (let item of this.queues)
                data["queues"].push(item.toJSON());
        }
        return data;
    }
}
export class QueueConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.queueId = _data["queueId"];
            this.name = _data["name"];
            this.priority = _data["priority"];
            this.enabled = _data["enabled"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new QueueConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["queueId"] = this.queueId;
        data["name"] = this.name;
        data["priority"] = this.priority;
        data["enabled"] = this.enabled;
        return data;
    }
}
export class GetRendererConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.rendererName = _data["rendererName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRendererConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["rendererName"] = this.rendererName;
        return data;
    }
}
export class GetRendererResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.renderer = _data["renderer"] ? RendererDetails.fromJS(_data["renderer"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRendererResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["renderer"] = this.renderer ? this.renderer.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class RendererDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ip = _data["ip"];
            this.machineName = _data["machineName"];
            this.operatingSystem = _data["operatingSystem"];
            this.hardDriveCapacity = _data["hardDriveCapacity"];
            this.hardDriveUsed = _data["hardDriveUsed"];
            this.gpu = _data["gpu"];
            this.gpuDriverVersion = _data["gpuDriverVersion"];
            this.launcherVersion = _data["launcherVersion"];
            this.launcherEnvironment = _data["launcherEnvironment"];
            this.queueCheckIntervalInMilliseconds = _data["queueCheckIntervalInMilliseconds"];
            this.cpuThreshold = _data["cpuThreshold"];
            this.gpuThreshold = _data["gpuThreshold"];
            this.canProcessMultipleJobs = _data["canProcessMultipleJobs"];
            this.dateLastHealthCheck = _data["dateLastHealthCheck"] ? new Date(_data["dateLastHealthCheck"].toString()) : undefined;
            this.rendererStatus = _data["rendererStatus"];
            this.canProcessRelease = _data["canProcessRelease"];
            this.rendererPool = _data["rendererPool"] ? RendererPool.fromJS(_data["rendererPool"]) : undefined;
            if (Array.isArray(_data["rendererQueues"])) {
                this.rendererQueues = [];
                for (let item of _data["rendererQueues"])
                    this.rendererQueues.push(RendererQueue.fromJS(item));
            }
            if (Array.isArray(_data["recipeEventSummaries"])) {
                this.recipeEventSummaries = [];
                for (let item of _data["recipeEventSummaries"])
                    this.recipeEventSummaries.push(RecipeEventSummary.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RendererDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ip"] = this.ip;
        data["machineName"] = this.machineName;
        data["operatingSystem"] = this.operatingSystem;
        data["hardDriveCapacity"] = this.hardDriveCapacity;
        data["hardDriveUsed"] = this.hardDriveUsed;
        data["gpu"] = this.gpu;
        data["gpuDriverVersion"] = this.gpuDriverVersion;
        data["launcherVersion"] = this.launcherVersion;
        data["launcherEnvironment"] = this.launcherEnvironment;
        data["queueCheckIntervalInMilliseconds"] = this.queueCheckIntervalInMilliseconds;
        data["cpuThreshold"] = this.cpuThreshold;
        data["gpuThreshold"] = this.gpuThreshold;
        data["canProcessMultipleJobs"] = this.canProcessMultipleJobs;
        data["dateLastHealthCheck"] = this.dateLastHealthCheck ? this.dateLastHealthCheck.toISOString() : undefined;
        data["rendererStatus"] = this.rendererStatus;
        data["canProcessRelease"] = this.canProcessRelease;
        data["rendererPool"] = this.rendererPool ? this.rendererPool.toJSON() : undefined;
        if (Array.isArray(this.rendererQueues)) {
            data["rendererQueues"] = [];
            for (let item of this.rendererQueues)
                data["rendererQueues"].push(item.toJSON());
        }
        if (Array.isArray(this.recipeEventSummaries)) {
            data["recipeEventSummaries"] = [];
            for (let item of this.recipeEventSummaries)
                data["recipeEventSummaries"].push(item.toJSON());
        }
        return data;
    }
}
export var RendererStatus;
(function (RendererStatus) {
    RendererStatus[RendererStatus["Idle"] = 0] = "Idle";
    RendererStatus[RendererStatus["Busy"] = 1] = "Busy";
    RendererStatus[RendererStatus["Updating"] = 2] = "Updating";
    RendererStatus[RendererStatus["Down"] = 3] = "Down";
})(RendererStatus || (RendererStatus = {}));
export class RendererPool {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RendererPool();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class RendererQueue {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.queueId = _data["queueId"];
            this.queueName = _data["queueName"];
            this.rendererId = _data["rendererId"];
            this.rendererName = _data["rendererName"];
            this.priority = _data["priority"];
            this.enabled = _data["enabled"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RendererQueue();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["queueId"] = this.queueId;
        data["queueName"] = this.queueName;
        data["rendererId"] = this.rendererId;
        data["rendererName"] = this.rendererName;
        data["priority"] = this.priority;
        data["enabled"] = this.enabled;
        return data;
    }
}
export class GetRendererRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRendererRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class GetRendererNamesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["rendererNames"])) {
                this.rendererNames = [];
                for (let item of _data["rendererNames"])
                    this.rendererNames.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRendererNamesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rendererNames)) {
            data["rendererNames"] = [];
            for (let item of this.rendererNames)
                data["rendererNames"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class GetRendererNamesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRendererNamesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class GetReportResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.label = _data["label"];
            if (_data["data"]) {
                this.data = {};
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data[key] = _data["data"][key];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}
export class GetReportRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            this.type = _data["type"];
            this.timePeriod = _data["timePeriod"];
            this.productId = _data["productId"];
            this.productSku = _data["productSku"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        data["type"] = this.type;
        data["timePeriod"] = this.timePeriod;
        data["productId"] = this.productId;
        data["productSku"] = this.productSku;
        return data;
    }
}
export var ReportType;
(function (ReportType) {
    ReportType[ReportType["MostPopularProduct"] = 0] = "MostPopularProduct";
    ReportType[ReportType["DailyProductViewTotal"] = 1] = "DailyProductViewTotal";
    ReportType[ReportType["MostPopularRoom"] = 2] = "MostPopularRoom";
})(ReportType || (ReportType = {}));
export class GetUsageSummaryReportResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {};
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data[key] = _data["data"][key] ? CompanyUsageData.fromJS(_data["data"][key]) : new CompanyUsageData();
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsageSummaryReportResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key] ? this.data[key].toJSON() : undefined;
            }
        }
        super.toJSON(data);
        return data;
    }
}
export class CompanyUsageData {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.company = _data["company"];
            this.renderRequests = _data["renderRequests"];
            this.renderTime = _data["renderTime"];
            this.viewRequests = _data["viewRequests"];
            this.productCallouts = _data["productCallouts"];
            this.storageConsumed = _data["storageConsumed"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyUsageData();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["renderRequests"] = this.renderRequests;
        data["renderTime"] = this.renderTime;
        data["viewRequests"] = this.viewRequests;
        data["productCallouts"] = this.productCallouts;
        data["storageConsumed"] = this.storageConsumed;
        return data;
    }
}
export class GetUsageSummaryReportRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.type = _data["type"];
            this.timePeriod = _data["timePeriod"] ? new Date(_data["timePeriod"].toString()) : undefined;
            this.year = _data["year"];
            this.month = _data["month"];
            this.day = _data["day"];
            this.hour = _data["hour"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsageSummaryReportRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["type"] = this.type;
        data["timePeriod"] = this.timePeriod ? this.timePeriod.toISOString() : undefined;
        data["year"] = this.year;
        data["month"] = this.month;
        data["day"] = this.day;
        data["hour"] = this.hour;
        return data;
    }
}
export var UsageSummaryType;
(function (UsageSummaryType) {
    UsageSummaryType[UsageSummaryType["Hour"] = 0] = "Hour";
    UsageSummaryType[UsageSummaryType["Day"] = 1] = "Day";
    UsageSummaryType[UsageSummaryType["Month"] = 2] = "Month";
    UsageSummaryType[UsageSummaryType["Year"] = 3] = "Year";
})(UsageSummaryType || (UsageSummaryType = {}));
export class IsReportReadyResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.isReady = _data["isReady"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IsReportReadyResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isReady"] = this.isReady;
        super.toJSON(data);
        return data;
    }
}
export class IsReportReadyRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IsReportReadyRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class PagedResponseOfProductImpressionView extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(ProductImpressionView.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfProductImpressionView();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListProductImpressionsResponse extends PagedResponseOfProductImpressionView {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListProductImpressionsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ProductImpressionView {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.manufacturer = _data["manufacturer"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.action = _data["action"];
            this.builder = _data["builder"];
            this.home = _data["home"];
            this.masterFile = _data["masterFile"];
            this.room = _data["room"];
            this.artifactId = _data["artifactId"];
            this.product = _data["product"];
            this.totalImpressions = _data["totalImpressions"];
            this.billableImpressions = _data["billableImpressions"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductImpressionView();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["manufacturer"] = this.manufacturer;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["action"] = this.action;
        data["builder"] = this.builder;
        data["home"] = this.home;
        data["masterFile"] = this.masterFile;
        data["room"] = this.room;
        data["artifactId"] = this.artifactId;
        data["product"] = this.product;
        data["totalImpressions"] = this.totalImpressions;
        data["billableImpressions"] = this.billableImpressions;
        return data;
    }
}
export class ListProductImpressionsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.manufacturer = _data["manufacturer"];
            this.manufacturerCompanyId = _data["manufacturerCompanyId"];
            this.reportType = _data["reportType"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined;
            this.productSku = _data["productSku"];
            this.productName = _data["productName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListProductImpressionsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["manufacturer"] = this.manufacturer;
        data["manufacturerCompanyId"] = this.manufacturerCompanyId;
        data["reportType"] = this.reportType;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined;
        data["productSku"] = this.productSku;
        data["productName"] = this.productName;
        super.toJSON(data);
        return data;
    }
}
export var ProductImpressionReportType;
(function (ProductImpressionReportType) {
    ProductImpressionReportType[ProductImpressionReportType["Default"] = 0] = "Default";
    ProductImpressionReportType[ProductImpressionReportType["PerProduct"] = 1] = "PerProduct";
    ProductImpressionReportType[ProductImpressionReportType["PerManufacturer"] = 2] = "PerManufacturer";
    ProductImpressionReportType[ProductImpressionReportType["PerManufacturerDetail"] = 3] = "PerManufacturerDetail";
    ProductImpressionReportType[ProductImpressionReportType["PerRoom"] = 4] = "PerRoom";
})(ProductImpressionReportType || (ProductImpressionReportType = {}));
export class ListProductImpressionsGraphDataResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["graphPoints"])) {
                this.graphPoints = [];
                for (let item of _data["graphPoints"])
                    this.graphPoints.push(ProductImpressionGraphPoint.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListProductImpressionsGraphDataResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.graphPoints)) {
            data["graphPoints"] = [];
            for (let item of this.graphPoints)
                data["graphPoints"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ProductImpressionGraphPoint {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined;
            this.totalImpressionCount = _data["totalImpressionCount"];
            this.billableImpressionCount = _data["billableImpressionCount"];
            this.panoramaViewCount = _data["panoramaViewCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductImpressionGraphPoint();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["totalImpressionCount"] = this.totalImpressionCount;
        data["billableImpressionCount"] = this.billableImpressionCount;
        data["panoramaViewCount"] = this.panoramaViewCount;
        return data;
    }
}
export class ListProductImpressionsGraphDataRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.manufacturer = _data["manufacturer"];
            this.manufacturerCompanyId = _data["manufacturerCompanyId"];
            this.productSKU = _data["productSKU"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined;
            this.isCumulative = _data["isCumulative"];
            this.timeScale = _data["timeScale"];
            this.productName = _data["productName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListProductImpressionsGraphDataRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["manufacturer"] = this.manufacturer;
        data["manufacturerCompanyId"] = this.manufacturerCompanyId;
        data["productSKU"] = this.productSKU;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined;
        data["isCumulative"] = this.isCumulative;
        data["timeScale"] = this.timeScale;
        data["productName"] = this.productName;
        return data;
    }
}
export var TimeScale;
(function (TimeScale) {
    TimeScale[TimeScale["Hour"] = 0] = "Hour";
    TimeScale[TimeScale["Day"] = 1] = "Day";
    TimeScale[TimeScale["Month"] = 2] = "Month";
    TimeScale[TimeScale["Auto"] = 3] = "Auto";
})(TimeScale || (TimeScale = {}));
export class PagedResponseOfQueueDetails extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(QueueDetails.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfQueueDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListQueuesResponse extends PagedResponseOfQueueDetails {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueuesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class QueueDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["rendererQueues"])) {
                this.rendererQueues = [];
                for (let item of _data["rendererQueues"])
                    this.rendererQueues.push(RendererQueue.fromJS(item));
            }
            if (Array.isArray(_data["recipeEventSummaries"])) {
                this.recipeEventSummaries = [];
                for (let item of _data["recipeEventSummaries"])
                    this.recipeEventSummaries.push(RecipeEventSummary.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new QueueDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.rendererQueues)) {
            data["rendererQueues"] = [];
            for (let item of this.rendererQueues)
                data["rendererQueues"].push(item.toJSON());
        }
        if (Array.isArray(this.recipeEventSummaries)) {
            data["recipeEventSummaries"] = [];
            for (let item of this.recipeEventSummaries)
                data["recipeEventSummaries"].push(item.toJSON());
        }
        return data;
    }
}
export class ListQueuesRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.searchTerm = _data["searchTerm"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueuesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        super.toJSON(data);
        return data;
    }
}
export class PagedResponseOfRecipeEventSummary extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(RecipeEventSummary.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfRecipeEventSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListRecipeEventSummariesResponse extends PagedResponseOfRecipeEventSummary {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListRecipeEventSummariesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ListRecipeEventSummariesRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.productName = _data["productName"];
            this.recipeStatus = _data["recipeStatus"];
            this.isComplete = _data["isComplete"];
            if (Array.isArray(_data["containsWords"])) {
                this.containsWords = [];
                for (let item of _data["containsWords"])
                    this.containsWords.push(item);
            }
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListRecipeEventSummariesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["productName"] = this.productName;
        data["recipeStatus"] = this.recipeStatus;
        data["isComplete"] = this.isComplete;
        if (Array.isArray(this.containsWords)) {
            data["containsWords"] = [];
            for (let item of this.containsWords)
                data["containsWords"].push(item);
        }
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined;
        super.toJSON(data);
        return data;
    }
}
export var RecipeStatus;
(function (RecipeStatus) {
    RecipeStatus[RecipeStatus["Complete"] = 0] = "Complete";
    RecipeStatus[RecipeStatus["Queued"] = 1] = "Queued";
    RecipeStatus[RecipeStatus["Cancelled"] = 2] = "Cancelled";
    RecipeStatus[RecipeStatus["InProgress"] = 3] = "InProgress";
    RecipeStatus[RecipeStatus["Failed"] = 4] = "Failed";
})(RecipeStatus || (RecipeStatus = {}));
export class PagedResponseOfRendererDetails extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(RendererDetails.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfRendererDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListRenderersResponse extends PagedResponseOfRendererDetails {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListRenderersResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ListRenderersRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            this.isBusyOnly = _data["isBusyOnly"];
            this.includeLatestJob = _data["includeLatestJob"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListRenderersRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        data["isBusyOnly"] = this.isBusyOnly;
        data["includeLatestJob"] = this.includeLatestJob;
        super.toJSON(data);
        return data;
    }
}
export class PagedResponseOfSessionSummary extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(SessionSummary.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfSessionSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListSessionsResponse extends PagedResponseOfSessionSummary {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListSessionsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SessionSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.interactions = _data["interactions"];
            this.sessionStart = _data["sessionStart"] ? new Date(_data["sessionStart"].toString()) : undefined;
            this.sessionEnd = _data["sessionEnd"] ? new Date(_data["sessionEnd"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SessionSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["interactions"] = this.interactions;
        data["sessionStart"] = this.sessionStart ? this.sessionStart.toISOString() : undefined;
        data["sessionEnd"] = this.sessionEnd ? this.sessionEnd.toISOString() : undefined;
        return data;
    }
}
export class ListSessionsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListSessionsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        super.toJSON(data);
        return data;
    }
}
export class PagedResponseOfSituConnectSummary extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(SituConnectSummary.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfSituConnectSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListSituConnectSummariesResponse extends PagedResponseOfSituConnectSummary {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListSituConnectSummariesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SituConnectSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.artifactId = _data["artifactId"];
            this.connectType = _data["connectType"];
            this.customerName = _data["customerName"];
            this.customerReference = _data["customerReference"];
            if (Array.isArray(_data["baseIngredients"])) {
                this.baseIngredients = [];
                for (let item of _data["baseIngredients"])
                    this.baseIngredients.push(BaseIngredient.fromJS(item));
            }
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : undefined;
            this.dateCompleted = _data["dateCompleted"] ? new Date(_data["dateCompleted"].toString()) : undefined;
            this.dateFailed = _data["dateFailed"] ? new Date(_data["dateFailed"].toString()) : undefined;
            this.totalSecondsAtRenderer = _data["totalSecondsAtRenderer"];
            this.sourceName = _data["sourceName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SituConnectSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["artifactId"] = this.artifactId;
        data["connectType"] = this.connectType;
        data["customerName"] = this.customerName;
        data["customerReference"] = this.customerReference;
        if (Array.isArray(this.baseIngredients)) {
            data["baseIngredients"] = [];
            for (let item of this.baseIngredients)
                data["baseIngredients"].push(item.toJSON());
        }
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : undefined;
        data["dateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : undefined;
        data["dateFailed"] = this.dateFailed ? this.dateFailed.toISOString() : undefined;
        data["totalSecondsAtRenderer"] = this.totalSecondsAtRenderer;
        data["sourceName"] = this.sourceName;
        return data;
    }
}
export class ListSituConnectSummariesRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.recipeStatus = _data["recipeStatus"];
            this.isComplete = _data["isComplete"];
            this.searchTerm = _data["searchTerm"];
            this.connectType = _data["connectType"];
            this.sourceName = _data["sourceName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListSituConnectSummariesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["recipeStatus"] = this.recipeStatus;
        data["isComplete"] = this.isComplete;
        data["searchTerm"] = this.searchTerm;
        data["connectType"] = this.connectType;
        data["sourceName"] = this.sourceName;
        super.toJSON(data);
        return data;
    }
}
export class PagedResponseOfUsageSummary extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(UsageSummary.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfUsageSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListUsageSummariesResponse extends PagedResponseOfUsageSummary {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListUsageSummariesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UsageSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.company = _data["company"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined;
            this.usageSummaryType = _data["usageSummaryType"];
            this.renderRequests = _data["renderRequests"];
            this.renderQueueTime = _data["renderQueueTime"];
            this.renderTime = _data["renderTime"];
            this.viewHomeRequests = _data["viewHomeRequests"];
            this.viewRoomRequests = _data["viewRoomRequests"];
            this.viewFacadeRequests = _data["viewFacadeRequests"];
            this.viewPlanRequests = _data["viewPlanRequests"];
            this.viewRenderRequests = _data["viewRenderRequests"];
            this.viewVirtualRealityRequests = _data["viewVirtualRealityRequests"];
            this.viewVanityRequests = _data["viewVanityRequests"];
            this.viewProductRequests = _data["viewProductRequests"];
            this.viewConnectRequests = _data["viewConnectRequests"];
            this.productCallouts = _data["productCallouts"];
            this.productCalloutsProducts = _data["productCalloutsProducts"];
            this.productCalloutsHomes = _data["productCalloutsHomes"];
            this.storageConsumed = _data["storageConsumed"];
            this.storageConsumedTotal = _data["storageConsumedTotal"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UsageSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["company"] = this.company;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined;
        data["usageSummaryType"] = this.usageSummaryType;
        data["renderRequests"] = this.renderRequests;
        data["renderQueueTime"] = this.renderQueueTime;
        data["renderTime"] = this.renderTime;
        data["viewHomeRequests"] = this.viewHomeRequests;
        data["viewRoomRequests"] = this.viewRoomRequests;
        data["viewFacadeRequests"] = this.viewFacadeRequests;
        data["viewPlanRequests"] = this.viewPlanRequests;
        data["viewRenderRequests"] = this.viewRenderRequests;
        data["viewVirtualRealityRequests"] = this.viewVirtualRealityRequests;
        data["viewVanityRequests"] = this.viewVanityRequests;
        data["viewProductRequests"] = this.viewProductRequests;
        data["viewConnectRequests"] = this.viewConnectRequests;
        data["productCallouts"] = this.productCallouts;
        data["productCalloutsProducts"] = this.productCalloutsProducts;
        data["productCalloutsHomes"] = this.productCalloutsHomes;
        data["storageConsumed"] = this.storageConsumed;
        data["storageConsumedTotal"] = this.storageConsumedTotal;
        return data;
    }
}
export class ListUsageSummariesRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.type = _data["type"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined;
            this.includeAll = _data["includeAll"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListUsageSummariesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["type"] = this.type;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined;
        data["includeAll"] = this.includeAll;
        super.toJSON(data);
        return data;
    }
}
export class PagedResponseOfViewHomeLogItem extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(ViewHomeLogItem.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfViewHomeLogItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListViewHomeLogItemsResponse extends PagedResponseOfViewHomeLogItem {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListViewHomeLogItemsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ViewHomeLogItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.clientIp = _data["clientIp"];
            this.dateRequested = _data["dateRequested"] ? new Date(_data["dateRequested"].toString()) : undefined;
            this.dateCompleted = _data["dateCompleted"] ? new Date(_data["dateCompleted"].toString()) : undefined;
            this.type = _data["type"];
            this.home = _data["home"];
            this.size = _data["size"];
            this.builder = _data["builder"];
            this.homeName = _data["homeName"];
            this.facade = _data["facade"];
            this.theme = _data["theme"];
            this.room = _data["room"];
            this.options = _data["options"];
            this.renderIp = _data["renderIp"];
            this.waitTimeInSeconds = _data["waitTimeInSeconds"];
            this.totalTimeInSeconds = _data["totalTimeInSeconds"];
            this.result = _data["result"];
            this.sessionId = _data["sessionId"];
            this.artifactId = _data["artifactId"];
            this.productName = _data["productName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ViewHomeLogItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientIp"] = this.clientIp;
        data["dateRequested"] = this.dateRequested ? this.dateRequested.toISOString() : undefined;
        data["dateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : undefined;
        data["type"] = this.type;
        data["home"] = this.home;
        data["size"] = this.size;
        data["builder"] = this.builder;
        data["homeName"] = this.homeName;
        data["facade"] = this.facade;
        data["theme"] = this.theme;
        data["room"] = this.room;
        data["options"] = this.options;
        data["renderIp"] = this.renderIp;
        data["waitTimeInSeconds"] = this.waitTimeInSeconds;
        data["totalTimeInSeconds"] = this.totalTimeInSeconds;
        data["result"] = this.result;
        data["sessionId"] = this.sessionId;
        data["artifactId"] = this.artifactId;
        data["productName"] = this.productName;
        return data;
    }
}
export class ListViewHomeLogItemsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined;
            this.search = _data["search"];
            this.ownerId = _data["ownerId"];
            this.clientIp = _data["clientIp"];
            this.type = _data["type"];
            this.home = _data["home"];
            this.builder = _data["builder"];
            this.room = _data["room"];
            this.facade = _data["facade"];
            this.theme = _data["theme"];
            this.options = _data["options"];
            this.size = _data["size"];
            this.waitTimeInSeconds = _data["waitTimeInSeconds"];
            this.totalTimeInSeconds = _data["totalTimeInSeconds"];
            this.result = _data["result"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListViewHomeLogItemsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined;
        data["search"] = this.search;
        data["ownerId"] = this.ownerId;
        data["clientIp"] = this.clientIp;
        data["type"] = this.type;
        data["home"] = this.home;
        data["builder"] = this.builder;
        data["room"] = this.room;
        data["facade"] = this.facade;
        data["theme"] = this.theme;
        data["options"] = this.options;
        data["size"] = this.size;
        data["waitTimeInSeconds"] = this.waitTimeInSeconds;
        data["totalTimeInSeconds"] = this.totalTimeInSeconds;
        data["result"] = this.result;
        super.toJSON(data);
        return data;
    }
}
export class AddQueueResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddQueueResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}
export class AddQueueRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddQueueRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export class CreateDailyProductImpressionCsvReportResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.reportId = _data["reportId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDailyProductImpressionCsvReportResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        super.toJSON(data);
        return data;
    }
}
export class CreateDailyProductImpressionCsvReportRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.ownerId = _data["ownerId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined;
            this.timeZone = _data["timeZone"];
            this.reportType = _data["reportType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDailyProductImpressionCsvReportRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined;
        data["timeZone"] = this.timeZone;
        data["reportType"] = this.reportType;
        return data;
    }
}
export class CreateLegacyMonthlyCsvReportResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.reportId = _data["reportId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLegacyMonthlyCsvReportResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        super.toJSON(data);
        return data;
    }
}
export class CreateLegacyMonthlyCsvReportRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.month = _data["month"];
            this.year = _data["year"];
            this.ownerId = _data["ownerId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLegacyMonthlyCsvReportRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        data["ownerId"] = this.ownerId;
        return data;
    }
}
export class CreateProductImpressionCsvReportResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.reportId = _data["reportId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductImpressionCsvReportResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        super.toJSON(data);
        return data;
    }
}
export class CreateProductImpressionCsvReportRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.ownerId = _data["ownerId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined;
            this.manufacturer = _data["manufacturer"];
            this.manufacturerCompanyId = _data["manufacturerCompanyId"];
            this.reportType = _data["reportType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductImpressionCsvReportRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined;
        data["manufacturer"] = this.manufacturer;
        data["manufacturerCompanyId"] = this.manufacturerCompanyId;
        data["reportType"] = this.reportType;
        return data;
    }
}
export class CreateViewHomeLogItemsCsvReportResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.reportId = _data["reportId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateViewHomeLogItemsCsvReportResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        super.toJSON(data);
        return data;
    }
}
export class CreateViewHomeLogItemsCsvReportRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined;
            this.search = _data["search"];
            this.ownerId = _data["ownerId"];
            this.clientIp = _data["clientIp"];
            this.type = _data["type"];
            this.home = _data["home"];
            this.builder = _data["builder"];
            this.room = _data["room"];
            this.facade = _data["facade"];
            this.theme = _data["theme"];
            this.options = _data["options"];
            this.size = _data["size"];
            this.waitTimeInSeconds = _data["waitTimeInSeconds"];
            this.totalTimeInSeconds = _data["totalTimeInSeconds"];
            this.result = _data["result"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateViewHomeLogItemsCsvReportRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined;
        data["search"] = this.search;
        data["ownerId"] = this.ownerId;
        data["clientIp"] = this.clientIp;
        data["type"] = this.type;
        data["home"] = this.home;
        data["builder"] = this.builder;
        data["room"] = this.room;
        data["facade"] = this.facade;
        data["theme"] = this.theme;
        data["options"] = this.options;
        data["size"] = this.size;
        data["waitTimeInSeconds"] = this.waitTimeInSeconds;
        data["totalTimeInSeconds"] = this.totalTimeInSeconds;
        data["result"] = this.result;
        return data;
    }
}
export class RendererHealthcheckResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RendererHealthcheckResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class RendererHealthcheckRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.lastHealthyAt = _data["lastHealthyAt"] ? new Date(_data["lastHealthyAt"].toString()) : undefined;
            this.version = _data["version"];
            this.name = _data["name"];
            this.ip = _data["ip"];
            this.currentTask = _data["currentTask"];
            this.rendererStatus = _data["rendererStatus"];
            if (_data["metaData"]) {
                this.metaData = {};
                for (let key in _data["metaData"]) {
                    if (_data["metaData"].hasOwnProperty(key))
                        this.metaData[key] = _data["metaData"][key];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RendererHealthcheckRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["lastHealthyAt"] = this.lastHealthyAt ? this.lastHealthyAt.toISOString() : undefined;
        data["version"] = this.version;
        data["name"] = this.name;
        data["ip"] = this.ip;
        data["currentTask"] = this.currentTask;
        data["rendererStatus"] = this.rendererStatus;
        if (this.metaData) {
            data["metaData"] = {};
            for (let key in this.metaData) {
                if (this.metaData.hasOwnProperty(key))
                    data["metaData"][key] = this.metaData[key];
            }
        }
        return data;
    }
}
export class UpdateRendererQueueResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRendererQueueResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateRendererQueueRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.priority = _data["priority"];
            this.enabled = _data["enabled"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRendererQueueRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["priority"] = this.priority;
        data["enabled"] = this.enabled;
        return data;
    }
}
export class UpdateRendererQueuePrioritiesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRendererQueuePrioritiesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateRendererQueuePrioritiesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (_data["rendererQueueIds"]) {
                this.rendererQueueIds = {};
                for (let key in _data["rendererQueueIds"]) {
                    if (_data["rendererQueueIds"].hasOwnProperty(key))
                        this.rendererQueueIds[key] = _data["rendererQueueIds"][key];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRendererQueuePrioritiesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (this.rendererQueueIds) {
            data["rendererQueueIds"] = {};
            for (let key in this.rendererQueueIds) {
                if (this.rendererQueueIds.hasOwnProperty(key))
                    data["rendererQueueIds"][key] = this.rendererQueueIds[key];
            }
        }
        return data;
    }
}
export class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
